import React from "react";
import PortalHeader from "./portalLayout/PortalHeader";
import PortalFooter from "./portalLayout/PortalFooter";
import { Outlet } from "react-router-dom";
import FriendLinksFloat from "../components/FriendLinksFloat";

const PortalLayout = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <PortalHeader />
      <main className="flex-grow-1">
        <Outlet />
      </main>
      <PortalFooter />
      {/* <FriendLinksFloat /> */}
    </div>
  );
};

export default PortalLayout;
